export default {
  xs: 480,
  sm: 768,
  md: 960,
  lg: 1120,
  xl: 1280
}
